import { render } from "./create-new-user.vue?vue&type=template&id=2c579c76&scoped=true"
import script from "./create-new-user.vue?vue&type=script&lang=js"
export * from "./create-new-user.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./create-new-user.vue?vue&type=style&index=1&id=2c579c76&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c579c76"]])

export default __exports__